var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoteJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4702 1.07245C10.1635 0.97585 9.83652 0.97585 9.52981 1.07245L1.58328 3.57524C1.15048 3.71155 0.90488 4.1904 1.03472 4.64477C1.1482 5.0419 1.51093 5.2889 1.88949 5.25382C1.84321 5.39006 1.81834 5.53594 1.81834 5.68637V17.7116C1.81834 18.4232 2.36779 19 3.04558 19H16.9543C17.6321 19 18.1816 18.4232 18.1816 17.7116V5.68637C18.1816 5.53594 18.1567 5.39005 18.1104 5.25381C18.489 5.28894 18.8518 5.04193 18.9653 4.64477C19.0951 4.1904 18.8495 3.71155 18.4167 3.57524L10.4702 1.07245Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.4C6 8.17909 6.19898 8 6.44444 8H13.5556C13.801 8 14 8.17909 14 8.4V12C14 12.221 13.801 12.4001 13.5556 12.4001H6.44444C6.19898 12.4001 6 12.221 6 12V8.4Z",
    fill: "#EEF6FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7793 13.6C7.7793 13.379 7.97828 13.2 8.22374 13.2H11.7793C12.0248 13.2 12.2237 13.379 12.2237 13.6C12.2237 13.8209 12.0248 14 11.7793 14H8.22374C7.97828 14 7.7793 13.8209 7.7793 13.6Z",
    fill: "#EEF6FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55469 12.0002H10.4436V13.6003H9.55469V12.0002Z",
    fill: "#EEF6FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteJob);
export default __webpack_public_path__ + "static/media/remoteJob.228d5cd5.svg";
export { ForwardRef as ReactComponent };